import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"

const initialState = {
  id: null,
  label: ""
}

export const breadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState: initialState,
  reducers: {
    setBreadcrumbItem(state: any, { payload }: PayloadAction<{ id: number | string; label: string }>) {
      const initialData = { ...payload }

      state.id = initialData?.id
      state.label = initialData?.label
    }
  }
})

export const breadcrumbReducer = breadcrumbSlice.reducer

export const { setBreadcrumbItem } = breadcrumbSlice.actions

export const getBreadcrumb = (state: RootState) => state.breadcrumb
